import React from 'react';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import { PageTitle } from '@cordata/buffet';
import { SlideOut } from '~/components';
import classnames from 'classnames';
import styled from 'styled-components';

const Main = ({
  children, fluid, title, className, titleAction,
}) => (
  <Container
    fluid={fluid}
    className={classnames(className)}
  >
    {title && <PageTitle action={titleAction}>{title}</PageTitle>}

    {children}
  </Container>
);

Main.propTypes = {
  fluid: PropTypes.bool,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  titleAction: PropTypes.node,
};

Main.defaultProps = {
  fluid: true,
  title: undefined,
  className: '',
  titleAction: undefined,
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ centerMain }) => (centerMain ? '2fr 8fr 2fr' : '2fr 10fr')};
  grid-template-areas: ${({ centerMain }) => (centerMain ? 'aside main-body right-container' : 'aside main-body')};
  grid-template-areas: "aside main-body right-container";
  height: 100%;

  @media (max-width: 768px) {
    display: block;
  }

  .aside {
    grid-area: aside;
  }

  .main {
    grid-area: main-body;
  }

  .right-container {
    grid-area: right-container;
  }
`;

const PageLayout = ({
  Header,
  Footer,
  Left,
  SlideOut: SlideOutContent,
  centerMain,
  ...props
}) => (
  <>
    {Header && <Header />}

    <main>
      {Left ? (
        <div style={{ height: `calc(100vh ${Header ? '- 40px' : ''} ${Footer ? '- 56px' : ''})` }}>
          <Wrapper centerMain={centerMain}>
            <div className="aside d-print-none left-container border-dark border-right  ox-hidden oy-auto">
              {Left}
            </div>
            <div className="main-body d-print-full-width oy-auto">
              <Main {...props} className="my-3" />
            </div>

            {centerMain && <div className="border-left border-tertiary right-container" />}
          </Wrapper>
        </div>
      ) : (
        <Main {...props} className="my-3" />
      )}
    </main>

    {Footer && (
      <footer className="footer text-center text-muted border-dark border-top pt-3" style={{ 'flex-shrink': 0 }}>
        <Container>
          <Footer />
        </Container>
      </footer>
    )}

    {SlideOutContent && <SlideOut><SlideOutContent /></SlideOut>}
  </>
);

PageLayout.propTypes = {
  Header: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  Footer: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  Left: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  SlideOut: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  titleAction: PropTypes.node,
  centerMain: PropTypes.bool,
};

PageLayout.defaultProps = {
  Header: null,
  Footer: null,
  Left: null,
  SlideOut: null,
  title: undefined,
  titleAction: undefined,
  centerMain: true,
};

export default PageLayout;
